export default "__VITE_ASSET__d5e06398__"